<template>
    <div class="space-card">
      <div
      >
        <div
          :class="`monitCard ${item.is_up}`"
        >
          <div class="top w-100 wrapper-percentage overflow-hidden">
            <div :class="`h-100 ${item.is_up ? 'bg-success' : 'bg-red-body'} w-100`"></div>
          </div>
          <div class="monit-name">
            {{ item.port }}
          </div>
          
          <div>
            <strong>
              Status Backup:
            </strong>
            <span>
              {{ getBackupStatus(item) }}
            </span>
          </div>
          
          <div>
            <strong>
              Status Fazenda:
            </strong>
            <span>
              {{ getFarmStatus(item) }}
            </span>
          </div>

          <footer class="d-flex align-items-center" :class="item.isLoading ? 'justify-content-end' : 'justify-content-between'">
            <div v-if="isInactive && !item.isLoading">
              <div id="aside-info">
                Atualizado em {{item.time}}
              </div>
            </div>

            <div class="d-flex align-items-center justify-content-end justify-content-md-center">
              <div :class="`status ${item.is_up ? 'bg-success' : 'bg-red-body'}`">
                {{ item.is_up ? "ON" : "OFF" }}
              </div>
            </div>
          </footer>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  computed: {
    isInactive() {
      return !this.item.MANAGEMENT;
    }
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  methods: {
    getBackupStatus(item) {
      if(item.has_backup) {
        return "Feito";

      } else if(item.is_backup_on_queue) {
        return "Na fila";

      } else {
        return "Fora da lista de backup";

      }
    },
    getFarmStatus(item) {
      if(item.is_up) {
        return "De pé";

      } else {
        return "Fora do ar";

      }
    }
  }
}
</script>

<style scoped>
.wrapper-percentage {
  background-color: #cbcbcb;
}

.water-icon-excess {
  color: #2997a8 !important;
}

.monit-sector-main {
  width: 100%;
  transition: 0.1s;
  overflow-y: auto;
  height: 100%;
  margin: 0;
}
.card-icon {
  color: #9e9e9e;
  font-size: 13px;
}
.measure-info {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.EmptyRequest {
  width: 100%;
  padding: 10px;
  color: Black;
  font-size: 1.1rem;
  text-align: center;
}
.my-class {
  padding: 0;
}
.monitCard {
  min-height: 210px;
}
.filter-model {
  max-height: 180px;
  overflow-y: auto;
  overflow-x: hidden;
}

.badge-3v3 {
  height: 30px;
  width: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.badge-3v3 * {
  font-size: 20px;
}
</style>
